/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Reset_CancelInputs */

const vi_einvoice_draft_reset_cancel = /** @type {(inputs: Einvoice_Draft_Reset_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giữ bản đang sửa`)
};

/**

* @param {Einvoice_Draft_Reset_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_reset_cancel = /** @type {((inputs?: Einvoice_Draft_Reset_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Reset_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_reset_cancel(inputs)
});